module.exports = __webpack_public_path__ + "static/media/ab2014Logo.1b7444e6.png";